// src/components/forms/RegistryLinkedChip.tsx

import { useTranslate } from 'react-admin';
import { Chip } from '@mui/material';

/** List cell: marks a hotel or group that is already linked to the shared registry. */
export const RegistryLinkedChip = ({ record }: { record?: { directoryId?: string | null } }) => {
  const translate = useTranslate();
  if (!record?.directoryId) return null;
  return <Chip size="small" color="success" variant="outlined" label={translate('common.linked')} />;
};
